import type { ViewerClickTracking } from "@/lib/viewer-context";
function isValidPurchaseUrl(url: URL, origin?: string) {
  return (
    ["http:", "https:"].includes(url.protocol) &&
    (origin === undefined || url.origin === origin) &&
    ![url.username, url.password, url.search, url.hash].some(Boolean) &&
    /^\/r\/[A-Za-z0-9]{8}$/.test(url.pathname)
  );
}
/** Adds shared viewer context to one validated direct Rastr purchase URL. */
export function buildRastrPurchaseHref(
  purchaseUrl: string | null | undefined,
  tracking: ViewerClickTracking | null | undefined,
): string | null {
  if (!purchaseUrl) return null;
  try {
    const url = new URL(purchaseUrl);
    if (!isValidPurchaseUrl(url, tracking?.origin)) return null;
    if (tracking?.context) url.searchParams.set("ctx", tracking.context);
    return url.toString();
  } catch {
    return null;
  }
}
